//------------------------------------------------------------------------
// Main nav toggle
//------------------------------------------------------------------------
"use strict";
import Modal from "./modals";

const navModal = new Modal(document.querySelector("#nav"), {
  modalContentClass: "Nav-wrap"
});
